import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { getFileServerConfig } from '../services/api';

const FileServerPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fileServerConfig, setFileServerConfig] = useState(null);
  const formRef = useRef(null);
  const iframeRef = useRef(null);

  useEffect(() => {
    const fetchFileServerConfig = async () => {
      try {
        const config = await getFileServerConfig();
        setFileServerConfig(config.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching file server config:', err);
        setError('Failed to load file server configuration. Please check your settings.');
        setLoading(false);
      }
    };

    fetchFileServerConfig();
  }, []);

  useEffect(() => {
    if (fileServerConfig && formRef.current) {
      formRef.current.submit();
    }
  }, [fileServerConfig]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={3}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>File Server Management</Typography>
      <Box sx={{ width: '100%', height: 'calc(100vh - 200px)', border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden' }}>
        <form
          ref={formRef}
          action={`${fileServerConfig?.url}/login-submit`}
          method="POST"
          target="fileServerFrame"
          style={{ display: 'none' }}
        >
          <input type="hidden" name="username" value={fileServerConfig?.username || ''} />
          <input type="hidden" name="password" value={fileServerConfig?.password || ''} />
        </form>
        <iframe
          ref={iframeRef}
          name="fileServerFrame"
          title="File Server Content"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      </Box>
    </Box>
  );
};

export default FileServerPage;